import React from 'react';
import useLandlordData from '../hooks/useLandlordData';
import PaymentRow     from '../components/PaymentRow';

export default function Payments() {
  const { payments, loading, error } = useLandlordData();
  if (loading) return <p>Loading payments…</p>;
  if (error)   return <p>Error loading payments.</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>All Payments</h2>
      <PaymentRow payments={payments} />
    </div>
  );
}

const styles = {
  container: { padding: '2rem', fontFamily: 'Arial, sans-serif' },
  heading:   { fontSize: '1.5rem', marginBottom: '1rem' }
};